import { createSlice } from '@reduxjs/toolkit'
import { DeviceTypes } from 'features/Codes'
import api from 'api/axios/foka'
import { createAxiosThunk } from 'utils/reduxUtil'

export const fetchExposurePreview = createAxiosThunk(
  'dashboard/keywordExposurePreview/fetchExposurePreview',
  (noArgs, { getState }) => {
    const { deviceType, keyword } =
      getState().dashboard.operation.keywordExposurePreview
    const limit = deviceType === DeviceTypes.MOBILE ? 7 : 20
    return api.dashboard.getExposurePreview({
      device: deviceType.name,
      keyword,
      limit,
    })
  }
)

const initialState = {
  isLoading: false,
  isShow: false,
  keyword: null,
  deviceType: DeviceTypes.MOBILE,
  ads: [],
}

const keywordExposurePreviewSlice = createSlice({
  name: 'dashboard/keywordExposurePreview',

  initialState: {
    isLoading: false,
    isShow: false,
    keyword: null,
    deviceType: DeviceTypes.MOBILE,
    ads: [],
  },

  reducers: {
    showPreview: (state, { payload }) => {
      state.keyword = payload
      state.isShow = true
    },
    hidePreview: () => initialState,
    setDeviceType: (state, { payload }) => {
      state.deviceType = payload
    },
  },

  extraReducers: builder => {
    builder.addCase(fetchExposurePreview.pending, state => {
      state.isLoading = true
    })

    builder.addCase(fetchExposurePreview.fulfilled, (state, { payload }) => {
      state.ads = payload.ads
      state.isLoading = false
    })

    builder.addCase(fetchExposurePreview.rejected, state => {
      state.isLoading = false
    })
  },
})

const { actions, reducer } = keywordExposurePreviewSlice
export default reducer
export const { showPreview, setDeviceType, hidePreview } = actions
